<carm-alerts displayAlertsForPage="homepage" [isPublic]='true'></carm-alerts>

<div class='carm-h1'>
<carm-forms-page
  inLocalizedPageTitle="{{ 'application_features.portal' | translate }}"
  inLocalizedPageShortDescription="{{ 'application_features.portalInfo' | translate }}"
  [inBreadcrumbLevels]="levels"></carm-forms-page>
</div>
<div class="row">
  <div class="col-md-4 col-xs-12 pull-right lnkbx">
    <h2>
      <span class="carm-h2">{{ 'application_features.homepage.sections.mostRequested.title' | translate }}</span>
    </h2>
    <ul>
      <li>
        <a rel="noopener noreferrer"
          target="_blank"
          href="{{ 'application_features.homepage.sections.mostRequested.eManifestLink' | translate }}"
          class="carm-a"
          >{{ 'application_features.homepage.sections.mostRequested.eManifest' | translate }}</a
        >
      </li>
      <li>
        <a rel="noopener noreferrer"
          target="_blank"
          href="{{ 'application_features.homepage.sections.mostRequested.traderPortalLink' | translate  }}"
          class="carm-a"
          >{{ 'application_features.homepage.sections.mostRequested.traderPortal' | translate  }}</a
        >
      </li>
      <li>
        <a rel="noopener noreferrer"
           target="_blank"
           href="{{ 'application_features.homepage.sections.mostRequested.getStartedURL' | translate  }}"
           class="carm-a"
        >{{ 'application_features.homepage.sections.mostRequested.getStarted' | translate  }}</a
        >
      </li>
    </ul>
  </div>

  <section class="gc-srvinfo col-md-8 pull-left">
    <carm-index-page
      [inIndexPage]="indexPage"
      [hideTopTitleInfo]='true'
      [inColumnNumber]='6'
      [inIValue]='2'>
    </carm-index-page>
  </section>
</div>

